import "./DiySeoSoftware.module.css";
import Header from "@/reusable_sections/Header";
import Seoguide from "./sections/Seoguide";
import Definition from "./sections/Definition";
import Criteria from "./sections/Criteria";
import DiyProcess from "./sections/DiyProcess";
import Suitability from "./sections/Suitability";
import Pricing from "./sections/Pricing";
import Hikeseo from "./sections/Hikeseo";
import Comparison from "./sections/Comparison";
import Faq from "./sections/Faq";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function DiySeoSoftwarePage() {
  return <div>
      <Header />
      <Seoguide />
      <Definition />
      <Criteria />
      <DiyProcess />
      <Suitability />
      <Pricing />
      <Hikeseo />
      <Comparison />
      <Faq />
      <Consultation />
      <Footer />
    </div>;
}